import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTenantPath } from '../../lib/tenantPath';

const Flag = ({ on, children, tone }) => on ? <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${tone}`}>{children}</span> : null;

export const WorkloadTenderTable = ({ bucket }) => {
  const navigate = useNavigate();
  const tp = useTenantPath();
  if (!bucket.tenders.length) {
    return <div className="p-6 text-sm text-[#6D8E87]" data-testid="workload-table-empty">No open tenders for {bucket.name}.</div>;
  }
  return (
    <div className="overflow-x-auto" data-testid="workload-table">
      <table className="w-full text-sm">
        <thead className="bg-[#F4F9F7] text-[10px] uppercase tracking-widest text-[#6D8E87]">
          <tr>
            <th className="text-left px-4 py-2.5">Tender #</th>
            <th className="text-left px-4 py-2.5">Buyer</th>
            <th className="text-left px-4 py-2.5">Status</th>
            <th className="text-left px-4 py-2.5">Deadline</th>
            <th className="text-left px-4 py-2.5">Missing documents</th>
            <th className="text-left px-4 py-2.5">EMD validity</th>
          </tr>
        </thead>
        <tbody>
          {bucket.tenders.map((t) => (
            <tr
              key={t.id}
              onClick={() => navigate(tp(`/tenders/${t.id}`))}
              className="border-t border-[#E2ECEA] hover:bg-[#FAFDFC] cursor-pointer transition-colors"
              data-testid={`workload-row-${t.id}`}
            >
              <td className="px-4 py-2.5 font-mono text-[#052A23]">{t.tender_number}</td>
              <td className="px-4 py-2.5 text-[#052A23]">{t.buyer_name}</td>
              <td className="px-4 py-2.5 text-xs uppercase text-[#3B5A54]">{(t.status || '').replace(/_/g, ' ')}</td>
              <td className="px-4 py-2.5 text-[#3B5A54] whitespace-nowrap">
                {t.submission_deadline || '—'}{' '}
                <Flag on={t.overdue} tone="bg-rose-100 text-rose-700">OVERDUE</Flag>
                <Flag on={t.due_7d} tone="bg-amber-100 text-amber-800">≤7D</Flag>
              </td>
              <td className="px-4 py-2.5 text-xs text-orange-700">{t.missing_docs.length ? t.missing_docs.join(', ') : <span className="text-emerald-700">All uploaded</span>}</td>
              <td className="px-4 py-2.5 text-xs text-[#3B5A54] whitespace-nowrap">
                {t.emd_validity || '—'} <Flag on={t.emd_expiring} tone="bg-indigo-100 text-indigo-700">≤30D</Flag>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
